module.exports = __webpack_public_path__ + "img/ge.3de2e854.svg";